module.exports = __webpack_public_path__ + "static/media/image2.013dd4ab.jpeg";